module.exports = __webpack_public_path__ + "static/media/calculator.61be5fa0.svg";